import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { constant } from '../../../../app.constants';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';
import { ServiceProviderInterface } from '../../../../core/interfaces/service-provider.interface';
import { ServiceProviderService } from '../../../../core/services/service-provider.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';

@Component({
  selector: 'app-form-service-provider',
  templateUrl: './form-service-provider.component.html',
  styleUrls: ['./form-service-provider.component.scss']
})

export class FormServiceProviderComponent implements OnInit, OnDestroy {
  @Input() searchForm = false;
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  showLocation = true;
  formServiceProvider: FormGroup;
  mask = constant.MASK_PHONE;
  dataSource = [];
  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private serviceProviderService: ServiceProviderService,
    private sweetAlertHelper: SweetAlertHelper,
    private _loading: T2LoadingService
    ) {
    this.initForm();
  }

  ngOnInit() {
    this.onInitResetForm();
  }

  initForm() {
    this.formServiceProvider = this.fb.group({
      serviceproviderid: [],
      description: ['', Validators.required],
      speedcode: [],
      isactive: [true],
      streetaddress: ['', Validators.required],
      roomaptnumber: [],
      city: ['', Validators.required],
      state: ['', Validators.required],
      county: ['', Validators.required],
      zip: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      latitude: ['', Validators.required],
      longitude: ['', Validators.required],
      phonenumber: [''],
      alternatephonenumber: [''],
      faxnumber: [],
      upin: [],
      statelicense: [],
      npi: []
    });
  }

  get isEdit(): boolean {
    return this.formServiceProvider.controls['serviceproviderid'].value ? true : false;
  }

  onLoadLocation(location) {
    this.formServiceProvider.patchValue({
      streetaddress: location.streetaddress ? location.streetaddress : '',
      city: location.city ? location.city : '',
      state: location.state ? location.state : '',
      county: location.county ? location.county : '',
      zip: location.zip ? location.zip : '',
      latitude: location.latitude ? location.latitude : '',
      longitude: location.longitude ? location.longitude : '',
    });
  }

  onResetForm() {
    this.formServiceProvider.reset();
    this.formServiceProvider.get('isactive').setValue(true);
  }

  onSave() {
    if(this.formServiceProvider.invalid){
      this.sweetAlertHelper.captureException('Please review all the required fields');
      return;
    }
      const data: any = this.formServiceProvider.value;
      if (data.serviceproviderid) {
        this._loading.show();
        this.subscriptions.push(this.serviceProviderService.put(data)
          .finally(() => {
            this._loading.hiden();
          })
          .subscribe({
          next: (resp: any) => {
            this.onSuccess(resp);
            this.serviceProviderService.setCloseMergeServiProviders(true, true, true);
          },
          error: (error) => {
            this.sweetAlertHelper.captureException(error);
          }
        }));
      } else {
        this._loading.show();
        this.subscriptions.push(
          this.serviceProviderService.post(data)
            .finally(() => {
              this._loading.hiden();
            }).subscribe({
            next: (resp: any) => {
              this.onSuccess(resp);
              this.formServiceProvider.reset();
              this.serviceProviderService.setCloseMergeServiProviders(true, true, true);
              
            },
            error: (error) => {
              this.sweetAlertHelper.captureException(error);
            }
          }));
      }
    
  }

  onSuccess(resp: any) {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Success',
      text: resp.message,
      type: 'success'
    }).then(() => {
      this.serviceProviderService.saveOnSuccessfull$.emit(true);
      this.onClearLocation();
    });
  }

  onCancel() {
    this.formServiceProvider.reset();
    this.serviceProviderService.serviceProviderSelected$.emit(<ServiceProviderInterface>{ serviceproviderid: undefined });
    this.onClearLocation();
    this.close.emit(true);
  }

  /**
   * No preguntar por esto, toco pues el componente de locationes esta mal creado...
   */
  onClearLocation() {
    this.showLocation = false;
    setTimeout(() => this.showLocation = true, 100);
  }

  onInitResetForm() {
    this.subscriptions.push(
      this.serviceProviderService.dataServiceProviders$.subscribe((data: ServiceProviderInterface) => {
        if (data) {
          this.formServiceProvider.patchValue(data);
        } else {
          this.onResetForm();
          this.onClearLocation();
        }
      }
      ),
      this.serviceProviderService.newServiceProvider$.subscribe((data) => {
        this.onResetForm();
        this.onClearLocation();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/components/form-service-provider/form-service-provider.component.ts